// Owner-confirmed commercial details only. Empty fields are never shown to customers;
// they are listed in the private editor notes panel instead.
export const siteConfig = {
  checkoutUrl: '', // [CHECKOUT URL] — launch requirement
  price: null as number | null, // [CONFIRMED PRICE] — launch requirement, e.g. 27
  currencyCode: '', // [CURRENCY], e.g. 'USD'
  deliveryDetails: '', // [DELIVERY DETAILS]
  guaranteeTerms: '', // [GUARANTEE AND REFUND TERMS]
  paymentTerms: '', // [PAYMENT TERMS], e.g. 'One-time payment.'
  legalLinks: {
    terms: '',
    privacy: '',
    refund: '',
    contact: '',
  },
};
